<nav class="navigation">
  <ul>
    <li><a href="#">Downloads</a></li>
    <li><a href="#">FAQ</a></li>
  </ul>
</nav>
